import { FC } from "react";
import useLocales from "../../hooks/useLocales";
import LinkButton from "../buttons/LinkButton";

interface ICreateActions {
  path: string;
}

const CreateActions: FC<ICreateActions> = ({ path }) => {
  const { translate } = useLocales();
  return (
    <>
      <LinkButton
        id="listActionButton"
        icon="icon-format_list_bulleted"
        path={`/${path}`}
        name={translate("actions.list")}
      />
    </>
  );
};

export default CreateActions;
